import { useEffect, useState } from 'react';

const DESKTOP_BREAKPOINT = 768;
const SIDEBAR_STATE_KEY = 'atendabot-sidebar-open';

const getIsDesktop = () =>
  typeof window === 'undefined' ? true : window.innerWidth >= DESKTOP_BREAKPOINT;

export function useAtendabotSidebarChrome(startCollapsed = false) {
  const [isDesktop, setIsDesktop] = useState(getIsDesktop);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [sidebarOpen, setSidebarOpen] = useState<boolean>(() => {
    if (startCollapsed) return false;
    try {
      const stored = sessionStorage.getItem(SIDEBAR_STATE_KEY);
      if (stored === null) return true;
      return stored === 'true';
    } catch (_) {
      return true;
    }
  });

  useEffect(() => {
    const handler = () => {
      setIsDesktop(getIsDesktop());
      if (getIsDesktop()) setMobileMenuOpen(false);
    };
    window.addEventListener('resize', handler);
    return () => window.removeEventListener('resize', handler);
  }, []);

  useEffect(() => {
    try {
      sessionStorage.setItem(SIDEBAR_STATE_KEY, String(sidebarOpen));
    } catch (_) {}
  }, [sidebarOpen]);

  return {
    isDesktop,
    mobileMenuOpen,
    setMobileMenuOpen,
    sidebarOpen,
    setSidebarOpen,
  };
}
